// extracted by mini-css-extract-plugin
module.exports = {"primaryText":"dist-es__DonutChart__primaryText","primaryText--withSecondary":"dist-es__DonutChart__primaryText--withSecondary","secondaryText":"dist-es__DonutChart__secondaryText"};